import React from "react";
import "../styles/Error404.css";

const Error404 = () => (
  <div className="error404-bg">
    <div className="error404-content">
      <h1>Error 404</h1>
      <p>Sorry! This page doesn't exist</p>
    </div>
  </div>
);

export default Error404;
